"use client";

import { ReactLenis } from "lenis/react";
import { JSX } from "react";

interface SmoothScrollingProps {
    children: JSX.Element;
}

export function SmoothScrolling({ children }: SmoothScrollingProps) {
    return (
        <ReactLenis
            root
            options={{
                lerp: 0.06,
                smoothWheel: true,
                wheelMultiplier: 1,
                anchors: { offset: -84 },
            }}
        >
            {children}
        </ReactLenis>
    );
}
